import { Button, TextButton } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/modal/modal";
interface ExitProps {
  onCloseModal: () => void;
  onCloseExperience: () => void;
  onSkip: () => void;
  show: boolean;
}

export function SkipToRecomModal({ onCloseExperience, onCloseModal, onSkip, show }: ExitProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal show={show} fitContent close={onCloseModal} modalTitle={t("hybrid.introExit.title")}>
      <div className="text-black font-bold text-xl mb-6 mt-6">{t("hybrid.introExit.title")}</div>
      <div className="text-black font-normal text-base leading-5.25 mb-6">{t("hybrid.introExit.description")}</div>
      <div className="pb-7.5 flex flex-col">
        <Button loading={false} type="submit" onClick={onSkip}>
          {t("hybrid.introExit.seeBestSize")}
        </Button>
        <TextButton onClick={onCloseExperience}>{t("hybrid.introExit.leave")}</TextButton>
      </div>
    </Modal>
  );
}
